import { render } from "./PricesPage.vue?vue&type=template&id=1c8aa93e"
import script from "./PricesPage.vue?vue&type=script&lang=js"
export * from "./PricesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__